import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const fileImportHistoryApi = createAsyncThunk(
  "fileImportHistory",
  // async () => {
  //   const response = await axiosInstance.get("/report/clientImportHistory");
  //   return response.data;
  // }
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};
    if (name) {
      params.name = name;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/clientImportHistory", {
      params, 
    });
    if (response) {
      return response.data;
    }
  }
);

const fileImportHistorySlice = createSlice({
  name: "fileImportHistory",
  initialState: {
    fileImportHistory: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fileImportHistoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(fileImportHistoryApi.fulfilled, (state, action) => {
        state.fileImportHistory = action.payload;
        state.loading = false;
      })
      .addCase(fileImportHistoryApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default fileImportHistorySlice.reducer;

